import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import styled from 'styled-components'
import SimpleBar from 'simplebar-react';

import 'simplebar/dist/simplebar.min.css';

export const StoreSelectView = (props) => {
    
    const {data:stores} = props.data.getOrThrow()
    
    const [selectStore, setSelectstore] = useState(props.defaultValue.store)

    const {  handleSubmit } = useForm()

    const onSelectShop = () => {
        props.onNext(selectStore)
    }
       
    // ウィンドウの高さを取得
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    return (
        <div className="select_content">
            <div className="select_desc">
                <h2>[候補店舗表示]</h2>
                ご購入またはご契約のガス販売店を選択し、「店舗を選択する」ボタンを押してください。
            </div>
           
            <form  
                onSubmit={handleSubmit(onSelectShop)} 
                className="single_select" 
            >
                {
                stores.length === 0 &&
                <div className="al-c">「該当店舗がありません」</div>
            }
            <SimpleBar className="store_select_list" forceVisible="y" autoHide={false}>
                {
                stores.map((store,i) => {
                    let checked
                    if(selectStore){
                        selectStore.id === store.id ? checked = true : checked = false
                    }else{
                        checked = false
                    }
                    return (
                        <div className="f-checkbox" key={i}>
                            <input 
                            type="checkbox" 
                            name="shops"
                            id={`shop${i}`}
                            value={`${store.name} ${store.address}`}
                            checked={checked} 
                            onChange={() =>{ 
                                setSelectstore(store)
                            }} 
                            />
                            <label 
                            htmlFor={`shop${i}`}>
                                {store.name} {store.address}
                                </label>
                        </div>

                    )
                })
                }
            </SimpleBar>
            
                <FixButton className="block2">
                    <div className="block2_1"><button className="btn5" type="submit">店舗を選択する</button></div>
                    <div className="block2_2">
                        <a className="btn6" onClick={() => {props.closeStoreSelect()}}>戻る</a>
                    </div>
                </FixButton>
            </form>
        </div>
    )

}


const FixButton = styled.div`
    position: fixed; 
    bottom: 0px; 
    width: 100%; 
    max-width: 710px; 
    padding: 20px; 
    background: #fff; 
    z-index: 999;
    left: 50%;
    transform: translateX(-50%);
`